import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import AllLogsList from "../../../../../components/analytics/client/Aggregate/List/List";
import { Card } from "antd";
import LoginLogs from "../../../../../components/analytics/client/Aggregate/LoginLogs/LoginLogs";
import VendorFilter from "../../../../../components/VendorFilter/VendorFilter";
import { CardHeader } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AnalyticsActions } from "../../../actions";
import { getUserRole } from "../../../../../Utils/Storage";
import { useHistory } from "react-router-dom";
import NoAccess from "../../../../../components/NoAccess/NoAccess";
import CompareVendors from "../../../../../components/analytics/client/Aggregate/CompareVendors/CompareVendors";
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const clientAnalyticsData = useSelector(
    (state: any) => state.AnalyticsReducers
  );
  const { startDate, endDate } = clientAnalyticsData;
  const dispatch = useDispatch();
  const history = useHistory();
  const userRole = getUserRole() || null;
  const [hasAccess, setHasAccess] =React.useState(true);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  const handleFilterChange = (from: any, to: any) => {
    dispatch(AnalyticsActions.setStartDate(from));
    dispatch(AnalyticsActions.setEndDate(to));
  };

  return (
    hasAccess ?
    <Card className={classes.root}>
      <VendorFilter
        className="filter"
        startDate={startDate}
        endDate={endDate}
        handleFilterChange={handleFilterChange}
      ></VendorFilter>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab label="All Logs" {...a11yProps(0)} />
          <Tab label="Login" {...a11yProps(1)} />
          <Tab label="Compare Vendors" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <AllLogsList setAccessStatus = {(status) => setHasAccess(status)} startDate={startDate} endDate={endDate}></AllLogsList>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <LoginLogs setAccessStatus = {(status) => setHasAccess(status)} startDate={startDate} endDate={endDate}></LoginLogs>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <CompareVendors setAccessStatus = {(status) => setHasAccess(status)} startDate={startDate} endDate={endDate}></CompareVendors>
      </TabPanel>
    </Card>
    :
    <NoAccess></NoAccess>
  );
}
